import * as React from "react";
import { useTranslation } from "react-i18next";

import pageStyles from "./styles/RolesInfoStyles";
import ViewerImg from "assets/images/IconViewer.png";
import ArtistImg from "assets/images/IconArtist.png";
import CommerceImg from "assets/images/IconCommerce.png";
// import { Link } from "@mui/material";

const RolesInfoScreen = () => {
  const { t } = useTranslation();
  const styles = pageStyles();

  const renderContent = () => {
    return (
      <div className={styles.infoContainer}>
        <div className={styles.columnInfo}>
          <div className={styles.cardRole}>
            <div className={styles.containerIcon}>
              <img alt="viewer" src={ViewerImg} className={styles.imageIcon} />
            </div>
            <div className={styles.rowInfo}>
              <h3 className={styles.titleRole}>
                {t("pages.home.rolesInfo.labelViewer")}
              </h3>
              <p className={styles.descriptionRole}>
                Ser un fan activo te premia. Acumula $FROIN y úsalos para
                adquirir entradas a eventos y bonos de comercios.
              </p>
              {/* <Link className={styles.buttonRole} href="/profile-videos">
                Participar ahora
              </Link> */}
            </div>
          </div>
        </div>
        <div className={styles.columnInfo}>
          <div className={styles.cardRole}>
            <div className={styles.containerIcon}>
              <img alt="artist" src={ArtistImg} className={styles.imageIcon} />
            </div>
            <div className={styles.rowInfo}>
              <h3 className={styles.titleRole}>Artista</h3>
              <p className={styles.descriptionRole}>
                Con <b>Promoción Multimedia</b>, premia a tus fans por cada play
                y lleva la conexión con tu comunidad al siguiente nivel.
              </p>
              {/* <Link
                className={styles.buttonRole}
                href="/welcome?page=register-artist"
              >
                Registrar proyecto
              </Link> */}
            </div>
          </div>
        </div>
        <div className={styles.columnInfo}>
          <div className={styles.cardRole}>
            <div className={styles.containerIcon}>
              <img
                alt="commerce"
                src={CommerceImg}
                className={styles.imageIcon}
              />
            </div>
            <div className={styles.rowInfo}>
              <h3 className={styles.titleRole}>Comercio aliado</h3>
              <p className={styles.descriptionRole}>
                Conéctate con una nueva clientela. Nosotros te promocionamos, tú
                solo pones tu emprendimiento.
              </p>
              {/* <Link
                className={styles.buttonRole}
                href="/welcome?page=register-artist"
              >
                Postular comercio
              </Link> */}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <p className={styles.label}>¿Cómo puedes participar?</p>
      {renderContent()}
    </>
  );
};

export default RolesInfoScreen;
